import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { MODAL_TYPE_PRO_MYPAGE_CLIENT } from '../../../../../actions/ModalActions';
import { propShape } from '../../../../../helpers/custom-prop-types';
import { getModalValue } from '../../../../../helpers/modal';
import Modal from '../../../../Ui/Modal';
import ModalClientDetailMain from './Content/ModalClientDetailMain';
const ModalClientDetail = ({ client }) => (_jsx(Modal, Object.assign({ modalType: MODAL_TYPE_PRO_MYPAGE_CLIENT }, { children: _jsx(ModalClientDetailMain, { client: client }) })));
ModalClientDetail.propTypes = {
    client: propShape().isRequired,
};
const mapStateToProps = ({ modal }) => {
    const { item: { order }, } = getModalValue(modal, MODAL_TYPE_PRO_MYPAGE_CLIENT);
    const client = (order && order.client) || {};
    return { client };
};
const enhance = compose(connect(mapStateToProps));
export default enhance(ModalClientDetail);
